import React from 'react';
import HeartBroken from "../icons/HeartBroken";
import __ from "../utils/translator";
import styled from "styled-components";

export default function NoResults({
  message,
  tip = null,
}) {
  return (
    <Container>
      <HeartBroken />
      <h3>{message}</h3>
      {tip !== null && (
        <p>{tip}</p>
      )}
    </Container>
  );
}

const Container = styled.div`
  padding-top: 6rem;
  text-align: center;

  > svg {
    width: 4.5rem;
    height: 4.5rem;
  }

  > h3 {
    margin-bottom: 0;
    font-weight: bolder;
  }
`;
